import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router'; // Importar Router
import { HelpersService } from '../../services/tools/helpers.service';
import { ClientesService } from '../../services/clientes.service';
import { ClientesDetallesComponent } from '../detalles/clientes-detalles.component';

@Component({
    selector: 'app-clientes-listado',
    templateUrl: './clientes-listado.component.html'
})

export class ClientesListadoComponent implements OnInit {
    // Referencias a elementos del HTML
    @ViewChild('modalCliente') public modalCliente: any;
    @ViewChild('btnShowDeleteModal') btnShowDeleteModal: ElementRef;

    // Variables de datos
    public clientes: any[] = [];
    public clienteToDelete: any = null;
    public isLoading: boolean = false;

    public searchText: string = '';

    // Filtros de búsqueda
    public filters: any = {
        nombre: '',
        email: ''
    };

    // Paginación
    public page: number = 1;
    public pageSize: number = 0;
    public pageAll: number = 0;
    public paginationInfo = { from: null, to: null, total: null };

    constructor(
        private helperService: HelpersService,
        private service: ClientesService,
        private router: Router
    ) { }

    public ngOnInit() {
        this.getClientes();
    }

    /**
     * Obtiene los clientes desde la API aplicando filtros y página actual
     */
    public getClientes() {
        let filters = this.getActiveFilters();
        this.isLoading = true;

        this.service.getAll(filters).subscribe(
            (response) => {
                const jsonResult = response.json();
                if (jsonResult.content && jsonResult.content.data) {
                    const jsonContent = response.json().content;
                    // Si el backend devuelve paginación (objeto con .data), lo mapeamos
                    this.clientes = jsonContent.data;
                    // Actualizamos indicadores de paginación
                    this.page = jsonContent.current_page;
                    this.pageSize = jsonContent.per_page;
                    this.pageAll = jsonContent.total;
                    this.paginationInfo.from = jsonContent.from;
                    this.paginationInfo.to = jsonContent.to;
                    this.paginationInfo.total = jsonContent.total;
                }
                this.isLoading = false;
            },
            error => {
                this.isLoading = false;
                this.helperService.httpGlobalError(error);
                this.helperService.notification('ERROR', 'No se pudo cargar la lista de clientes.', 'error');
            }
        );
    }

    /**
     * Prepara los parámetros para la petición HTTP
     */
    private getActiveFilters() {
        let filters = {
            page: null,
            search: null,
            paginate: true
        };

        if (this.page) {
            filters.page = this.page;
        }

        if (this.searchText) {
            filters.search = this.searchText;
        }

        return filters;
    }

    /**
     * Ejecuta la búsqueda al presionar Enter o botón de buscar
     */
    public onSearch() {
        this.page = 1; // Reiniciar a la primera página al buscar
        this.getClientes();
    }

    /**
     * Cambiar de página (usado por el componente de paginación en el HTML)
     */
    public pageChanged(event: any) {
        this.page = event;
        this.getClientes();
    }

    // --- Acciones de Modal ---

    public addCliente() {
    this.router.navigate(['/clientes/cliente-form']);
    }

    public editCliente(idCliente: number) {
        // Ahora redirigimos a la ruta de edición en lugar de abrir modal
        this.router.navigate(['/clientes/cliente-form', idCliente]);
    }
    public verCliente(idCliente: number) {
        // Ahora redirigimos a la ruta de edición en lugar de abrir modal
        this.router.navigate(['/clientes/cliente-form/detalles', idCliente]);
    }

    public selectClienteToDelete(event: any, cliente: any) {
        if (event) event.stopPropagation();
        this.clienteToDelete = cliente;
        if (this.btnShowDeleteModal) {
            this.btnShowDeleteModal.nativeElement.click();
        }
    }

    public deleteCliente() {
        if (!this.clienteToDelete) return;

        this.service.delete(this.clienteToDelete.id).subscribe(
            (response) => {
                this.getClientes();
                this.helperService.notification('Cliente eliminado', 'Se ha eliminado exitosamente el cliente', 'success');
                this.clienteToDelete = null;
            },
            error => {
                this.helperService.httpGlobalError(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/clientes/listado/clientes-listado.component.ts